module.exports = __webpack_public_path__ + "img/2025010401.c060f14f.png";